import { useField } from 'formik';
import * as React from 'react';
import { FormControl } from 'react-bootstrap';
import { Field, getFieldPrimitiveFromString, getFieldStringFromPrimitive } from 'gossamer-unified';
import { General } from '../index';

export interface FormFieldProps {
  className?: string;
  clearOnSelection?: boolean;
  editable: boolean;
  fullId: string;
  field: Field;
}

export const FormField = (props: FormFieldProps): React.JSX.Element => {
  const [field, meta, helper] = useField({ name: props.fullId });
  return (
    <>
      <General
        className={props.className}
        editable={props.editable}
        fieldId={props.fullId}
        field={props.field}
        handleChange={(newValue: string | null) =>
          helper.setValue(getFieldPrimitiveFromString(props.field.type, newValue || ''))
        }
        validity={meta.touched ? !meta.error : undefined}
        value={getFieldStringFromPrimitive(props.field.type, field.value)}
      />
      {meta.error && meta.touched && <FormControl.Feedback type="invalid">{meta.error}</FormControl.Feedback>}
    </>
  );
};
